import React, { Component } from "react";
import { MsalContext } from "@azure/msal-react";


// Import components:
import Avatar from "@material-ui/core/Avatar";
import Dropdown from "react-bootstrap/Dropdown";
import fetchAPI from "../../../components/utils/fetchAPI";
import runtimeEnv from '@mars/heroku-js-runtime-env';

const env = runtimeEnv();

export default class DashboardHeader extends Component {
  static contextType = MsalContext;

  state = {
    buttonLogoutText: "Cerrar sesión",
    availableCountries: [{countryName: "Colombia", codeCountry: "CO", countryId: "mdcolombia"},{countryName:"México", codeCountry:"MX", countryId:"mdmexico"},],
  };

  handleDropdown = (selectedValue, evt) => {
    this.setState({
      selectedCountryPrev: evt.target.outerText,
      selectedCountryCodePrev: selectedValue,
    });
  }

  handleAvatar = (e) => {
    const buttonLogout = document.getElementById("dashboard-account-button-logout");
    const buttonLogoutWidth = buttonLogout.style.width;
    if(buttonLogoutWidth !== "132px") {
      buttonLogout.style.width = "132px";
    } else {
      buttonLogout.style.width = "0";
    }
  }

  handleLogout = (e) => {
    const msalInstance = this.context.instance;
    window.sessionStorage.removeItem("maz_abi_digitalsalesportal_front_copec_user_country");
    window.sessionStorage.removeItem("maz_abi_digitalsalesportal_front_copec_user_country_code");
    msalInstance.logout();
  }

  setSelectedCountry = (country) => {
    this.setState({
      selectedCountry: country,
    });
  };

  handleCountry = (countryId) => {
    localStorage.setItem("codeCountry", countryId)
    window.location.reload()
    //this.props.selectedCountry(this.state.selectedCountry)
  }

  render() {
    const userName = this.props.userData.userName;
    // const lastModify = this.props.userData.lastModify;
    const headerTitle = this.props.headerTitle;
    // this.handleCountry()
    return (
      <div className="dashboard__header">
        <div className="dashboard__logo"></div>

        <div className="dashboard__info">
          <div className="dashboard__title">{headerTitle}</div>

          <div className="dashboard__account">
            <div id="dashboard-account-button-logout" className="dashboard__logout">
              <button 
                className="dashboard__button dashboard__button--logout"
                type="button"
                onClick={this.handleLogout}
                >{this.state.buttonLogoutText}</button>
            </div>
            <div 
              style={this.props?.dataUser?.user?.clientPermission === "Administrador" ? {
                display: 'flex',
                } : {}
              }
            >
              <div className="dashboard__account__info">
                <div className="dashboard__user-name">{this.context.accounts[0].name}</div>
                <input id="exclution-data-user-id" type="hidden" value={this.props.userData.userPrincipalName} />
                <Avatar 
                  alt={userName} 
                  src={null}
                  id={`dashboar-avatar-button`}
                  onClick={this.handleAvatar} />
              </div>
              <Dropdown
                onSelect={this.handleDropdown}
                // disabled={true}
                className="dashboard__dropdown"
                style={
                  this.props?.dataUser?.user?.clientPermission === "Administrador" 
                  ?
                    {
                      display: 'flex',
                      alignItems: 'center',
                    }
                  : {
                      display: 'none'
                    }
                }
              >
                <Dropdown.Toggle id="dropdown-basic">
                  <img 
                    width="30" 
                    heigth="30" 
                    src={this.props.countriesCode === "mdcolombia" 
                      ? "/assets/banderas/colombia.svg" 
                      : this.props.countriesCode === "mdmexico"
                      ? "/assets/banderas/mexico.svg"
                      : this.props.countriesCode === "mdperu"
                      ? "/assets/banderas/PeruSinFondo.png"
                      : this.props.countriesCode === "mdecuador"
                      ? "/assets/banderas/ecuador.svg"
                      : this.props.countriesCode === "mdpanama"
                      ? "/assets/banderas/panama.svg"
                      : null
                    } 
                    alt="Country Selected"
                  />
                  <div className="dropdown__text">
                    {this.props.countriesCode === "mdcolombia" 
                        ? "CO" 
                        : this.props.countriesCode === "mdmexico"
                        ? "MX"
                        : this.props.countriesCode === "mdperu"
                        ? "PR"
                        : this.props.countriesCode === "mdecuador"
                        ? "EC"
                        : this.props.countriesCode === "mdpanama"
                        ? "PN"
                        : null}
                  </div>
                </Dropdown.Toggle>
                <Dropdown.Menu className="login__dropdown-menu">
                  {this.state.availableCountries.map((element) => (
                    element.countryId === this.props.countriesCode
                    ? <></> :
                    <Dropdown.Item eventKey={element.codeCountry}
                      style={{display:"flex"}}
                      onClick={e => this.handleCountry(element.countryId)}
                    >
                      <img 
                        width="30" 
                        heigth="30" 
                        src={element.countryName === "Colombia" 
                          ? "/assets/banderas/colombia.svg" 
                          : element.countryName === "México"
                          ? "/assets/banderas/mexico.svg"
                          : element.countryName === "Perú"
                          ? "/assets/banderas/PeruSinFondo.png"
                          : element.countryName === "Ecuador"
                          ? "/assets/banderas/ecuador.svg"
                          : element.countryName === "Panama"
                          ? "/assets/banderas/panama.svg"
                          : null
                        } 
                        alt="Country Select"
                      />
                      <span
                        className="login__dropdown-menuItem"
                      >
                        {element.codeCountry}
                      </span>
                    </Dropdown.Item>
                  ))}
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>

        </div>
      </div>
    );
  }
}
